import React from 'react';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PlusCircle, ChevronUp, Table, Grid } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { actions as mainActions, showModal } from 'Core/redux/main/slice';
import { actions as changeRequestActions } from './store/slice';
import { selectTileView } from './store/selectors';
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { MODAL_TYPES } from 'Feature/components/app-modals';

const { setToogleHeader } = mainActions;
const { setTileView } = changeRequestActions;
const { CHANGEREQUEST_ADD_EDIT } = MODAL_TYPES;

const ChangeRequestTopHead = () => {
  const dispatch = useDispatch();
  const data = useSelector(isHeaderVisible);
  const tileView = useSelector(selectTileView);

  const renderCollapseTooltip = props => <Tooltip {...props}>Collapse</Tooltip>;
  const renderTileViewTooltip = props => (
    <Tooltip {...props}>{tileView ? 'Table View' : 'Tile View'}</Tooltip>
  );

  return (
    <>
      <ul className="table-top-head">
        <li>
          <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
            <Link
              to="#"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              id="collapse-header"
              className={data ? 'active' : ''}
              onClick={() => dispatch(setToogleHeader(!data))}
            >
              <ChevronUp />
            </Link>
          </OverlayTrigger>
        </li>
        <li>
          <OverlayTrigger placement="top" overlay={renderTileViewTooltip}>
            <Link
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              onClick={() => dispatch(setTileView(!tileView))}
            >
              {tileView ? <Table /> : <Grid />}
            </Link>
          </OverlayTrigger>
        </li>
      </ul>
      <div className="d-flex purchase-pg-btn">
        <div className="page-btn">
          <Link
            to="#"
            className="btn btn-added"
            onClick={() => dispatch(showModal(CHANGEREQUEST_ADD_EDIT))}
          >
            <PlusCircle className="me-2" />
            New Change Request
          </Link>
        </div>
      </div>
    </>
  );
};

export default ChangeRequestTopHead;
